<home-wrapper [homeTab]="'CLIPBOARD'" [viewMode]="'table'" [ngClass]="{ onMenu: !selectedAccount }"  >
  <loader-pane-fragment [trace]="traceNames.viewClipboard"></loader-pane-fragment>

  <account-menu (openAccount)="openAccount($event)">
    <black-bar-wrapper
      *ngIf="!!selectedAccount"
      [noClose]="true"
    >
      <div class="header">{{ selectedAccount.title }}</div>
      <div class="inner-content">
        <joi-nav-wrapper
          [menuItems]="tabs"
          [selectedId]="selectedTab" 
          (selectItem)="changeTab($event)"
        ></joi-nav-wrapper>
        <ng-container *ngIf="!tableLoading && !tableData">
          <!--<div class="empty-templates">To add {{ selectedTab | lowercase }} to this clipboard, click on the [+ADD TO CLIPBOARD] button on the bottom left of any {{ selectedTab | lowercase }} in events from the account ({{ selectedAccount.text }}).</div>-->
          <div class="empty-templates">No {{ selectedTab | lowercase }} in this clipboard.</div>
        </ng-container>
        <ng-container *ngIf="!tableLoading && !!tableData">
          <ng-container *ngIf="selectedTab === 'PERFORMERS'" [ngTemplateOutlet]="table"></ng-container>
          <ng-container *ngIf="selectedTab === 'SPONSORS'" [ngTemplateOutlet]="table"></ng-container>
          <ng-container *ngIf="selectedTab === 'EXHIBITORS'" [ngTemplateOutlet]="table"></ng-container>
          <ng-container *ngIf="selectedTab === 'ASSETS'" [ngTemplateOutlet]="table"></ng-container>
          <ng-container *ngIf="selectedTab === 'RESOURCES'" [ngTemplateOutlet]="table"></ng-container>
          <ng-container *ngIf="selectedTab === 'ATTENDEES'" [ngTemplateOutlet]="table"></ng-container>
        </ng-container>
      </div>
    </black-bar-wrapper>
  </account-menu>
</home-wrapper>

<ng-template #table><!-- this is only to force refreshing when switching tabs -->
  <search-bar (keyword)="updateSearch($event)" [gray]="true" [placeholder]="'Search clipboard'" ></search-bar>
  <nested-table
    [items]="tableData"
    [columns]="columnData"
    [columnsById]="columnsById"
    [menuDisabled]="tableUpdating"
    [defaultSelectedColumnId]="'name'"
    [menuItems]="menuItems"
    [emptyMessage]="'No ' + (selectedTab | lowercase) + ' found'"
    (selectItem)="openTemplate($event)"
  ></nested-table>
</ng-template>